import type * as lazyPersonalOSReadingPane from './PersonalOSReadingPane';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyPersonalOSReadingPane> = new LazyModule(
    () => import(/* webpackChunkName: "PersonalOSReadingPane" */ './PersonalOSReadingPane'),
    { name: 'PersonalOSReadingPane' }
);

export const LazyPersonalOSReadingPane: LazyComponent<
    lazyPersonalOSReadingPane.PersonalOSReadingPaneProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.default);
